// @flow
import { gql, useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import * as selectors from '../selectors';

type UseScheduledDeployment = () => {
  scheduledDeployment: Object,
  isFetching: boolean,
}

const useScheduledDeployment: UseScheduledDeployment = () => {
  const { data, loading } = useQuery(QUERY);

  const { scheduledDeployment } = useSelector(mapStateToProps(data));

  return {
    isFetching: loading,
    scheduledDeployment
  };
};

const QUERY = gql`
query scheduledDeployment {
  scheduledDeployment {
    _id
    scheduledBy {
      username
    }
    version
    bucketName
    state
    data {
      pages {
        path
        version
      }
    }
    deployAt
    status
    notes
    deleted
  }
}
`;

/* =============================================================================
=    Redux
============================================================================= */
const mapStateToProps = (ownProps) => (state) => ({
  scheduledDeployment: selectors.getPagePathsForDataOnly(state, ownProps)
});

export default useScheduledDeployment;
